import { CountryCode } from '@/store/ui';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgPepperChatLink',
})
export default class CmgPepperChatLink extends Vue {
  get chatIconUrl(): string {
    return this.$appStore.state.cms.images.icons.chat.default;
  }

  onChatClick(): void {
    this.$services.pepperChat.openChatWindow();
  }

  get visible(): boolean {
    return  this.$appStore.state.ui.countryProfile.countryCode == CountryCode.US
  }
}
